<template>
  <Card class="elevation-2 pa-4 containerCards" :loading="processing">
    <div class="cardTitle">{{ $t('Профиль пользователя') }}</div>
    <v-form ref="form" :readonly="!editing">
      <Input
        label="Логин"
        placeholder="Введите логин"
        v-model="user.username"
        :error-messages="errors['username']"
        :rules="[].concat(validation.required(), validation.text(255))"
        :disabled="processing"
        :class="{ 'disabled': !editing }"
        @blur="checkExistsUser($event.target.value, 'username')"
        @input="errors['username'] = null"
        :required="editing"
      />
      <Input
        label="Фамилия"
        placeholder="Введите фамилию"
        v-model="user.lastName"
        :rules="[].concat(validation.required(), validation.text(255))"
        :disabled="processing"
        :class="{ 'disabled': !editing }"
        :required="editing"
      />
      <Input
        label="Имя"
        placeholder="Введите имя"
        v-model="user.firstName"
        :rules="[].concat(validation.required(), validation.text(255))"
        :disabled="processing"
        :class="{ 'disabled': !editing }"
        :required="editing"
      />
      <Input
        label="Отчество"
        placeholder="Введите отчество"
        v-model="user.middleName"
        :rules="[].concat(validation.text(255))"
        :disabled="processing"
        :class="{ 'disabled': !editing }"
      />
      <v-row>
        <v-col cols="6">
          <Input
            label="Адрес электронной почты"
            placeholder="Введите E-mail"
            v-model="user.email"
            :error-messages="errors['email']"
            :rules="[].concat(validation.required(), validation.email())"
            :disabled="processing"
            :class="{ 'disabled': !editing }"
            variant="solo"
            @blur="checkExistsUser($event.target.value, 'email')"
            @input="errors['email'] = null"
            :required="editing"
          />
        </v-col>
        <v-col cols="6">
          <Input
            label="Телефон"
            placeholder="Введите номер телефона"
            v-model="user.phone"
            :rules="[].concat(validation.required(), validation.phone())"
            :disabled="processing"
            :class="{ 'disabled': !editing }"
            variant="solo"
            :required="editing"
          />
        </v-col>
      </v-row>
      <Input
        label="Роль пользователя"
        v-model="user.role.name"
        :disabled="true"
        :class="{ 'disabled': true }"
      />
      <SelectInput
        label="Язык"
        no-data-text="Отсутствуют данные"
        v-model="user.lang"
        :items="langs"
        item-value="id"
        item-title="name"
        :disabled="processing"
        :class="{ 'disabled': !editing }"
      />
    </v-form>
    <v-card-actions>
      <div>
        <v-btn
          v-if="!editing"
          color="primary"
          density="comfortable"
          variant="outlined"
          :disabled="processing"
          @click="toPreviosPage()"
        >{{ $t('Назад') }}</v-btn>
        <v-btn
          v-if="editing"
          color="primary"
          density="comfortable"
          variant="outlined"
          :disabled="processing"
          @click="cancelAction()"
        >{{ $t('Отмена') }}</v-btn>
      </div>
      <div class="ml-auto" style="display: flex; gap: 10px;">
        <v-btn
          v-if="!editing"
          color="primary"
          density="comfortable"
          variant="elevated"
          :disabled="processing"
          @click="editAction()"
        >{{ $t('Редактировать') }}</v-btn>
        <v-btn
          v-if="editing"
          color="primary"
          density="comfortable"
          variant="elevated"
          :disabled="processing"
          @click="saveAction()"
        >{{ $t('Сохранить') }}</v-btn>
      </div>
    </v-card-actions>
  </Card>
</template>

<script>
  import api from '@/api';
  import { toast } from '@/lib/toast';
  import Config from "@/config";
  import {emitter} from "@/app";
  import Card from "@intec/vue-components/form/Card.vue";
  import Input from "@intec/vue-components/form/Input.vue";
  import validation from '@/components/validation';
  import { LANGS } from '@/lib/lang';
  import SelectInput from "@intec/vue-components/form/SelectInput.vue";

  export default {
    name: 'ProfileUser',
    components: {Card, Input, SelectInput},
    data() {
      return {
        editing: false,
        processing: false,
        errors: {
          'username': null,
          'email': null
        },
        user: {
          id: null,
          username: null,
          lastName: null,
          firstName: null,
          middleName: null,
          email: null,
          phone: null,
          lang: null,
          role: {
            code: null,
            name: null
          },
        },
        langs: LANGS,
        userMemory: {},
        emitter,
        validation,
      };
    },
    methods: {
      async load() {
        this.processing = true;
        try {
          const user = await api.get('/profile/user/load');
          this.user = user;
        } catch (e) {
          toast.error(e.message);
        }
        this.processing = false;
      },
      async saveAction() {
        this.processing = true;
        const hasErrors = Object.values(this.errors).some(value => value !== null);
        if ((await this.$refs.form.validate()).valid && !hasErrors) {
          try {
            let formData = new FormData();
            formData.append('data', JSON.stringify(this.user));
            await api.post('/profile/user/save', formData);
            this.emitter.emit('profileUpdate');
            this.editing = false;
            location.reload();
          } catch (e) {
            toast.error(e.message);
          }
        } else {
          toast.error('Проверьте правильность заполнения формы');
        }
        this.processing = false;
      },
      async checkExistsUser(value, type) {
        if (this.editing) {
          try {
            let user = Config.getUser();
            let formData = new FormData();
            formData.append('data', JSON.stringify({ userId: user.opts?.id, value, type }));
            await api.post('/auth/checkIfExists', formData);
            this.errors[type] = null;
          } catch (e) {
            this.errors[type] = e.message;
          }
        }
      },
      editAction() {
        this.editing = true;
        this.userMemory = {...this.user};
      },
      cancelAction() {
        this.editing = false;
        this.user = this.userMemory;
      },
      toPreviosPage() {
        history.back();
      }
    },
    created() {
      this.load();
    }
  };
</script>
